'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _ownerForm = require('./owner-form.component');

var _ownerForm2 = _interopRequireDefault(_ownerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvent.ownerForm', []).component('ownerForm', _ownerForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-event/owner-form/owner-form.module.js